import { graphql, PageProps } from 'gatsby';
import React from 'react';
import Layout from 'src/elements/layout/layout';
import Heading from 'elements/typography/heading'
import { LegalContainer, PoliciesCatalog } from 'organisms/legal/legal.styles';
import LinkSimple from 'elements/links/Link.simple';
import { HeadingContentfulModel } from 'src/api/models/Heading';
import { LegalArticleContentfulModel } from 'src/api/models/LegalArticle';
import PromotionModal from 'src/organisms/promotion/PromotionModal';

interface PoliciesSectionContentfulModel {
  label:
    | 'Policies Title Container'
    | 'Policies List Container';
  internal: {
    type: 'ContentfulSection';
  };
  contentfulchildren: Array<
    | HeadingContentfulModel
    | LegalArticleContentfulModel
  >;
}

interface PoliciesPageProps extends PageProps {
  data: {
    contentfulPage: {
      title: string;
      seoTitle: string;
      seoDescription?: string;
      displayPromotionModal?: boolean;
      seoImage?: {
        file?: {
          url: string;
        };
      };
      contentfulchildren: PoliciesSectionContentfulModel[];
    };
  };
}


const PoliciesPage = ({ data, location }: PoliciesPageProps): JSX.Element => {
  const contentfulPage = data.contentfulPage;
  const helmetData = {
    title: contentfulPage.seoTitle,
    description: contentfulPage.seoDescription
  }

  const titleSection = contentfulPage.contentfulchildren.find(data => data.label.includes('Policies Title Container')).contentfulchildren;
  const titleHeading = titleSection.find(data => data.internal.type === 'ContentfulHeading') as HeadingContentfulModel;

  const articleListSection = contentfulPage.contentfulchildren.find(data => data.label.includes('Policies List Container')).contentfulchildren;
  const articleList = articleListSection.filter(data => data.internal.type === 'ContentfulLegalArticle') as LegalArticleContentfulModel[];

  const displayModal = contentfulPage.displayPromotionModal;

  return (
    <Layout helmet={helmetData} location={location}>
      <LegalContainer>
        <Heading
          text={titleHeading.text}
          align="center"
          size="3.45em"
          sizeSm="1.875em"
        />
        <br />
        <br />
        <br />

        <PoliciesCatalog>
          {articleList.map((policyPage, index) => (
            <LinkSimple key={index} url={`/${policyPage.slug}`} color="main" text={policyPage.label} />
          ))}
        </PoliciesCatalog>
      </LegalContainer >
      <PromotionModal displayModal={displayModal}/>
    </Layout>
  )
}

export const pageQuery = graphql`
query PoliciesPageQuery {
  contentfulPage(contentful_id: {eq: "51W7A4i9vOWq6tHMUPKn9d"}) {
    seoTitle
    seoDescription
    seoImage {
      file {
        url
      }
    }
    displayPromotionModal
    contentfulchildren {
      id
      label
      contentfulchildren {
        ...HeadingContent
        ...LegalArticleContent
      }
    }
  }
}
`

export default PoliciesPage;
